import { render, staticRenderFns } from "./consultFeaturePopup.vue?vue&type=template&id=5a8b6238&scoped=true&"
import script from "./consultFeaturePopup.vue?vue&type=script&lang=js&"
export * from "./consultFeaturePopup.vue?vue&type=script&lang=js&"
import style0 from "./consultFeaturePopup.vue?vue&type=style&index=0&id=5a8b6238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b6238",
  null
  
)

export default component.exports